import { ThemeProvider as NextThemesProvider } from "next-themes";

// Light/dark theme provider. next-themes persists the choice under the
// `theme` key in localStorage automatically. We hardcode:
//   - attribute="class"      → toggles the `dark` class on <html>, which is
//                              the mode Tailwind's `darkMode: ["class"]` and
//                              shadcn/ui expect.
//   - defaultTheme="light"   → every fresh visitor starts in light.
//   - enableSystem={false}   → we do NOT auto-follow the OS preference; the
//                              user's explicit choice is the only source of
//                              truth once they toggle.
export default function ThemeProvider({ children }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="light"
      enableSystem={false}
      disableTransitionOnChange
    >
      {children}
    </NextThemesProvider>
  );
}
